import { API_BASE } from "../../config/api";
import React, { useMemo } from "react";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

/*export function getModalDims(screens) {
  if (!screens.sm) {
    return { width: "92vw", bodyStyle: { maxHeight: "70vh", overflowY: "auto", padding: 16 }, centered: true };
  }
  if (screens.sm && !screens.md) {
    return { width: 480, bodyStyle: { maxHeight: "72vh", overflowY: "auto", padding: 16 }, centered: true };
  }
  return { width: 640, bodyStyle: { maxHeight: "75vh", overflowY: "auto", padding: 16 }, centered: true };
}*/
// BEFORE
// export function getModalDims(screens) {

// AFTER
export function getModalDims(screens = {}) {
  const sm = !!screens.sm; // safe booleans
  const md = !!screens.md;

  if (!sm) {
    return {
      width: "92vw",
      bodyStyle: { maxHeight: "70vh", overflowY: "auto", padding: 16 },
      centered: true,
    };
  }
  if (sm && !md) {
    return {
      width: 480,
      bodyStyle: { maxHeight: "72vh", overflowY: "auto", padding: 16 },
      centered: true,
    };
  }
  return {
    width: 640,
    bodyStyle: { maxHeight: "75vh", overflowY: "auto", padding: 16 },
    centered: true,
  };
}


export function LedgerResponsiveWrapper({ children }) {
  const screens = useBreakpoint();
  const isXS = !screens.sm;
  const isSM = screens.sm && !screens.md;

  const scale = useMemo(() => {
    if (isXS) return 0.70;
    if (isSM) return 0.80;
    return 1;
  }, [isXS, isSM]);

  const outer = { width: "100%", overflowX: "auto", padding: 8 };
  const scaler = { transform: `scale(${scale})`, transformOrigin: "top left", width: `${(1 / scale) * 100}%` };

  return (
    <div style={outer}>
      <div style={scaler}>{children}</div>
    </div>
  );
}

export function mobileAwareColumns(columns, { keepOnMobile = [] } = {}) {
  return columns.map((col) => {
    const key = col.key || col.dataIndex || col.title;
    const base = {
      ...col,
      onCell: () => ({ style: { padding: "6px 8px", fontSize: 12, lineHeight: 1.2 } }),
      onHeaderCell: () => ({ style: { padding: "6px 8px", fontSize: 12, lineHeight: 1.2 } }),
      ellipsis: col.ellipsis ?? true,
    };

    if (Array.isArray(base.children)) {
      base.children = mobileAwareColumns(base.children, { keepOnMobile });
      const hasImportantChild = base.children.some((c) => {
        const ck = c.key || c.dataIndex || c.title;
        return ck && keepOnMobile.includes(ck);
      });
      if (!hasImportantChild) base.responsive = ["md"];
      return base;
    }

    if (!keepOnMobile.includes(key)) {
      base.responsive = ["md"];
    }
    return base;
  });
}

export const denseTableProps = {
  size: "small",
  sticky: true,
  scroll: { x: "max-content" },
  pagination: { pageSize: 20, showSizeChanger: false },
  tableLayout: "auto",
  bordered: true,
};

export { API_BASE };
export const getArn = () => localStorage.getItem("arn_number");

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const day = String(d.getDate()).padStart(2, "0");
  const mon = d.toLocaleString("en-US", { month: "short" });
  const year = d.getFullYear();
  return `${day}-${mon}-${year}`;
};
